import { Box, InputBase, Typography, useTheme } from "@mui/material";
import type { ChangeEvent } from "react";
import { VALUE_LINE_HEIGHT } from "web_myplann/Shared/Components/FlatRow/constants";

type Props = {
	label: string;
	value: string;
	onChange: (value: string) => void;
	placeholder?: string;
	isLast?: boolean;
};

export const FlatRowStackedInput = ({
	label,
	value,
	onChange,
	placeholder,
	isLast,
}: Props) => {
	const { palette, spacingTokens } = useTheme();

	const handleChange = (event: ChangeEvent<HTMLInputElement>) => {
		onChange(event.target.value);
	};

	return (
		<Box
			component="label"
			display="block"
			width="100%"
			px={spacingTokens.lg}
			py={spacingTokens.md}
			borderBottom={isLast ? "none" : `1px solid ${palette.surface.border}`}
		>
			<Typography
				variant="body2"
				color={palette.grey[500]}
				mb={spacingTokens.xs}
			>
				{label}
			</Typography>
			<InputBase
				value={value}
				onChange={handleChange}
				placeholder={placeholder}
				fullWidth
				sx={{
					p: 0,
					"& input": {
						p: 0,
						fontSize: 14,
						fontWeight: 500,
						lineHeight: `${VALUE_LINE_HEIGHT}px`,
						height: VALUE_LINE_HEIGHT,
						color: palette.text.primary,
						"&::placeholder": {
							color: palette.grey[300],
							fontWeight: 400,
							opacity: 1,
						},
					},
				}}
			/>
		</Box>
	);
};
